import React, { lazy, useMemo } from "react";

/**
 * Hook to retrieve the renderer map for SDM SDUI.
 */
export const useRendererMap = () => {
  return useMemo<Record<string, React.LazyExoticComponent<React.FC<any>>>>(
    () => ({
      bentoCardContainerComponent: lazy(() =>
        import(
          "../components/bento-cards-container/bento-cards-container.component"
        ).then(({ BentoCardsContainerComponent }) => ({
          default: BentoCardsContainerComponent,
        }))
      ),
      chipGroupComponent: lazy(() =>
        import("../components/chip-group/chip-group.component").then(
          ({ ChipGroupComponent }) => ({
            default: ChipGroupComponent,
          })
        )
      ),
      heroComponent: lazy(() =>
        import("../components/hero-banner/hero-banner.component").then(
          ({ HeroBannerComponent }) => ({
            default: HeroBannerComponent,
          })
        )
      ),
      stackedProductCarouselComponent: lazy(() =>
        import(
          "../components/mini-product-tile-carousel/mini-product-tile-carousel.component"
        ).then(({ MiniProductTileCarouselComponent }) => ({
          default: MiniProductTileCarouselComponent,
        }))
      ),
      bannerWithHeadlineComponent: lazy(() =>
        import(
          "../components/banner-with-headline/banner-with-headline.component"
        ).then(({ BannerWithHeadlineComponent }) => ({
          default: BannerWithHeadlineComponent,
        }))
      ),
      productCarouselComponent: lazy(() =>
        import(
          "../components/product-carousel/product-carousel.component"
        ).then(({ ProductCarouselComponent }) => ({
          default: ProductCarouselComponent,
        }))
      ),
      brandSpotlightComponent: lazy(() =>
        import("../components/brand-spotlight/brand-spotlight.component").then(
          ({ BrandSpotlightComponent }) => ({
            default: BrandSpotlightComponent,
          })
        )
      ),
      menuTileCarouselComponent: lazy(() =>
        import(
          "../components/menu-tile-carousel/menu-tile-carousel.component"
        ).then(({ MenuTileCarouselComponent }) => ({
          default: MenuTileCarouselComponent,
        }))
      ),
      headerGroupComponent: lazy(() =>
        import("../components/header-group/header-group.component").then(
          ({ HeaderGroupComponent }) => ({
            default: HeaderGroupComponent,
          })
        )
      ),
      productGridComponent: lazy(() =>
        import(
          "../components/simple-product-grid/simple-product-grid.component"
        ).then(({ SimpleProductGridComponent }) => ({
          default: SimpleProductGridComponent,
        }))
      ),
      quickFiltersComponent: lazy(() =>
        import("../components/quick-filters/quick-filters.component").then(
          ({ QuickFiltersComponent }) => ({
            default: QuickFiltersComponent,
          })
        )
      ),
      sortsComponent: lazy(() =>
        import("../components/sort/sort.component").then(
          ({ SortComponent }) => ({
            default: SortComponent,
          })
        )
      ),
      filtersComponent: lazy(() =>
        import("../components/filters/filters.component").then(
          ({ FiltersComponent }) => ({
            default: FiltersComponent,
          })
        )
      ),
      sortComponent: lazy(() =>
        import("../components/sort/sort.component").then(
          ({ SortComponent }) => ({
            default: SortComponent,
          })
        )
      ),
      bannerCarouselComponent: lazy(() =>
        import("../components/banner-carousel/banner-carousel.component").then(
          ({ BannerCarouselComponent }) => ({
            default: BannerCarouselComponent,
          })
        )
      ),
      verticalFeatureCardContainerComponent: lazy(() =>
        import(
          "../components/vertical-feature-card/vertical-feature-card.component"
        ).then(({ VerticalFeatureCardComponent }) => ({
          default: VerticalFeatureCardComponent,
        }))
      ),
      horizontalFeatureCardContainerComponent: lazy(() =>
        import(
          "../components/horizontal-feature-card-collection/horizontal-feature-card-collection.component"
        ).then(({ HorizontalFeatureCardCollection }) => ({
          default: HorizontalFeatureCardCollection,
        }))
      ),
      provinceListComponent: lazy(() =>
        import(
          "../components/province-selector/province-selector.component"
        ).then(({ ProvinceSelectorComponent }) => ({
          default: ProvinceSelectorComponent,
        }))
      ),
      searchBarComponent: lazy(() =>
        import("../components/search-bar/search-bar.component").then(
          ({ SearchBarComponent }) => ({
            default: SearchBarComponent,
          })
        )
      ),
      infoCardContainerComponent: lazy(() =>
        import(
          "../components/info-card-container/info-card-container.component"
        ).then(({ InfoCardContainerComponent }) => ({
          default: InfoCardContainerComponent,
        }))
      ),
      miniInfoCardContainerComponent: lazy(() =>
        import(
          "../components/mini-info-card-container/mini-info-card-container.component"
        ).then(({ MiniInfoCardContainerComponent }) => ({
          default: MiniInfoCardContainerComponent,
        }))
      ),
      footerContentComponent: lazy(() =>
        import("../components/footer/footer.component").then(
          ({ FooterComponent }) => ({
            default: FooterComponent,
          })
        )
      ),
      tableComponent: lazy(() =>
        import("../components/table/table.component").then(
          ({ TableComponent }) => ({
            default: TableComponent,
          })
        )
      ),
      /* mediaShoppableDisplayComponent: lazy(() =>
        import(
          "../components/media-shoppable-display-component/media-shoppable-display-component.component"
        ).then(({ MediaShoppableDisplayComponent }) => ({
          default: MediaShoppableDisplayComponent,
        }))
      ), */
      /* mediaIABComponent: lazy(() =>
        import(
          "../components/media-iab-component/media-iab-component.component"
        ).then(({ MediaIabComponent }) => ({
          default: MediaIabComponent,
        }))
      ), */
      fireworkComponent: lazy(() =>
        import("../components/firework/firework.component").then(
          ({ FireworkComponent }) => ({
            default: FireworkComponent,
          })
        )
      ),
      // NEW TEST RENDER MAPS
      filterChipComponent: lazy(() =>
        import("../components/filter-chip/filter-chip.component").then(
          ({ FilterChipComponent }) => ({
            default: FilterChipComponent,
          })
        )
      ),
      paginationComponent: lazy(() =>
        import("../components/pagination/pagination.component").then(
          ({ PaginationComponent }) => ({
            default: PaginationComponent,
          })
        )
      ),
    }),
    []
  );
};

export default useRendererMap;

// TODO:  Add mock data, you got it from Notion doc (JSON ReSPONSE)
// TODO: Setup SDM app and test component
